import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  bannerBox: {
    width: '100%',
    marginLeft: 24,
  },
  reportLink: {
    display: 'block',
    width: 98,
    height: 32,
    transform: 'translateX(100%)',
    color: '#fff',
    fontSize: 12,
    lineHeight: '28px',
    letterSpacing: 1,
    textAlign: 'center',
    cursor: 'pointer',
    outline: 'none',
    backgroundColor: 'transparent',
    borderRadius: 4,
    border: '1px solid #fff',
  },
})

const Title = () => (
  <Typography
    variant="h6"
    style={{
      color: '#fff',
      lineHeight: 1.2,
      marginBottom: 13,
    }}
  >
    Отчет сквозной
    <br />
    аналитики
  </Typography>
)

const Link = ({ classNames }) => (
  <a
    className={classNames}
    target="_blank"
    rel="noopener noreferrer"
    href="/reports/analytics"
  >
    Смотреть
  </a>
)

const BannerReportAnalitycsV2 = ({ classes }) => {
  return (
    <div className={classes.bannerBox}>
      <Title />
      <Link classNames={classes.reportLink} />
    </div>
  )
}

export default withStyles(styles)(BannerReportAnalitycsV2)
